// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"66affb33","312":"135ca265","395":"61337a85","584":"2e03b161"}[chunkId] + ".chunk.js";
};